import { Routes } from '@angular/router';
import { LandingComponent } from './features/home/pages/landing/landing.component';
import { ListMedecinComponent } from './features/home/pages/list-medecin/list-medecin.component';
import { ListStructuresComponent } from './features/home/pages/list-structures/list-structures.component';
import { ListPharmaciesComponent } from './features/home/pages/list-pharmacies/list-pharmacies.component';
import { RegistrationComponent } from './features/auth/pages/registration/registration.component';
import { PassportLayoutComponent } from './features/passport/components/layout/passport-layout.component';
import { PassportDashboardComponent } from './features/passport/pages/dashboard/dashboard.component';
import { AppointmentsListeComponent } from './features/passport/pages/appointments/liste/liste.component';
import { InsurancesListeComponent } from './features/passport/pages/insurances/liste/liste.component';
import { InsurancesDetailsComponent } from './features/passport/pages/insurances/details/details.component';
import { PatientRecordOverviewComponent } from './features/passport/pages/patient_record/overview/overview.component';
import { AuthorizationsListeComponent } from './features/passport/pages/authorizations/liste/liste.component';
import { HealthTrackingComponent } from './features/passport/pages/health-tracking/health-tracking.component';
import { HealthEventDetailsComponent } from './features/passport/pages/health-tracking/details/health-event-details.component';
import { PaymentsListeComponent } from './features/passport/pages/payments/liste/liste.component';
import { PassportCardComponent } from './features/passport/pages/card/card.component';
import { ProfilLayoutComponent } from './features/profil/components/layout/profil-layout.component';
import { GeneralInfoComponent } from './features/profil/pages/general-info/general-info.component';
import { ChangePasswordComponent } from './features/profil/pages/change-password/change-password.component';
import { ActivitiesComponent } from './features/profil/pages/activities/activities.component';
import { ManagedAccountsComponent } from './features/profil/pages/managed-accounts/managed-accounts.component';
import { PreferencesComponent } from './features/profil/pages/preferences/preferences.component';
import { AuthGuard } from './core/guards/auth.guard';
import { MedecinDetailsComponent } from './features/home/pages/medecin-details/medecin-details.component';
import { StructureDetailsComponent } from './features/home/pages/structure-details/structure-details.component';
import { PharmacieDetailsComponent } from './features/home/pages/pharmacie-details/pharmacie-details.component';
import { CountryGuard } from './core/guards/country.guard';
import { MenuAccessGuard } from './core/guards/menu-access.guard';
import { CountryRedirectComponent } from './core/components/country-redirect/country-redirect.component';
import { ForbiddenComponent } from './core/pages/forbidden/forbidden.component';
import { CguComponent } from './features/passport/components/cgu/cgu.component';
import { LiensComponent } from './features/home/pages/liens/liens.component';
import { MainLayoutComponent } from './shared/components/layout/main-layout/main-layout.component';
import { CountryLayoutComponent } from './shared/components/layout/country-layout/country-layout.component';

export const routes: Routes = [
  // Route racine - redirige vers le pays par défaut si disponible, sinon vers home
  {
    path: '',
    component: CountryRedirectComponent,
  },

  // Page /liens : sans navbar ni footer (hors layout principal)
  { path: 'liens', component: LiensComponent },

  // Routes avec layout principal (navbar + footer)
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: LandingComponent },
      { path: 'medecins', component: ListMedecinComponent },
      { path: 'medecins/:id', component: MedecinDetailsComponent },
      { path: 'structures', component: ListStructuresComponent },
      { path: 'structures/:id', component: StructureDetailsComponent },
      { path: 'pharmacies', component: ListPharmaciesComponent },
      { path: 'pharmacies/:id', component: PharmacieDetailsComponent },
      { path: 'register', component: RegistrationComponent },
      { path: 'cgu', component: CguComponent },
      { path: '403', component: ForbiddenComponent },

      // Passport routes (protégées)
      {
        path: 'passport',
        component: PassportLayoutComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
          { path: 'dashboard', component: PassportDashboardComponent },
          {
            path: 'appointments',
            component: AppointmentsListeComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'insurances',
            component: InsurancesListeComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'insurances/:contractId',
            component: InsurancesDetailsComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'patient-record',
            component: PatientRecordOverviewComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'authorizations',
            component: AuthorizationsListeComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'authorizations/:view',
            component: AuthorizationsListeComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'health-tracking',
            component: HealthTrackingComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'health-tracking/:eventId',
            component: HealthEventDetailsComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'payments',
            component: PaymentsListeComponent,
            canActivate: [MenuAccessGuard],
          },
          {
            path: 'card',
            component: PassportCardComponent,
            canActivate: [MenuAccessGuard],
          },
        ],
      },

      // Profil routes (protégées)
      {
        path: 'profil',
        component: ProfilLayoutComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'general-info', pathMatch: 'full' },
          { path: 'general-info', component: GeneralInfoComponent },
          { path: 'change-password', component: ChangePasswordComponent },
          { path: 'activities', component: ActivitiesComponent },
          { path: 'managed-accounts', component: ManagedAccountsComponent },
          { path: 'preferences', component: PreferencesComponent },
        ],
      },
    ],
  },

  // Routes avec code pays (:country) - layout principal ou page liens
  {
    path: ':country',
    component: CountryLayoutComponent,
    canActivate: [CountryGuard],
    children: [
      // Page /:country/liens : sans navbar ni footer
      { path: 'liens', component: LiensComponent },

      // Routes avec layout principal (navbar + footer)
      {
        path: '',
        component: MainLayoutComponent,
        children: [
          { path: '', component: LandingComponent },
          { path: 'home', component: LandingComponent },
          { path: 'medecins', component: ListMedecinComponent },
          { path: 'medecins/:id', component: MedecinDetailsComponent },
          { path: 'structures', component: ListStructuresComponent },
          { path: 'structures/:id', component: StructureDetailsComponent },
          { path: 'pharmacies', component: ListPharmaciesComponent },
          { path: 'pharmacies/:id', component: PharmacieDetailsComponent },
          { path: 'register', component: RegistrationComponent },
          { path: 'cgu', component: CguComponent },
          { path: '403', component: ForbiddenComponent },

          // Passport routes (protégées)
          {
            path: 'passport',
            component: PassportLayoutComponent,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
              { path: 'dashboard', component: PassportDashboardComponent },
              {
                path: 'appointments',
                component: AppointmentsListeComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'insurances',
                component: InsurancesListeComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'insurances/:contractId',
                component: InsurancesDetailsComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'patient-record',
                component: PatientRecordOverviewComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'authorizations',
                component: AuthorizationsListeComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'authorizations/:view',
                component: AuthorizationsListeComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'health-tracking',
                component: HealthTrackingComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'health-tracking/:eventId',
                component: HealthEventDetailsComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'payments',
                component: PaymentsListeComponent,
                canActivate: [MenuAccessGuard],
              },
              {
                path: 'card',
                component: PassportCardComponent,
                canActivate: [MenuAccessGuard],
              },
            ],
          },

          // Profil routes (protégées)
          {
            path: 'profil',
            component: ProfilLayoutComponent,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: 'general-info', pathMatch: 'full' },
              { path: 'general-info', component: GeneralInfoComponent },
              { path: 'change-password', component: ChangePasswordComponent },
              { path: 'activities', component: ActivitiesComponent },
              { path: 'managed-accounts', component: ManagedAccountsComponent },
              { path: 'preferences', component: PreferencesComponent },
            ],
          },
        ],
      },
    ],
  },

  // Route de fallback - redirige vers la page d'accueil
  { path: '**', redirectTo: '/home' },
];
